import gql from 'graphql-tag';
export const rugbyLeagueStatFragment = gql `
  fragment LeagueStats on RugbyLeagueStats {
    tries
    points
    conversions
    penaltyGoals
    dropGoals
  }
`;
//# sourceMappingURL=RugbyLeagueStats.js.map